// Zmiana etykiety sortowania
document.addEventListener('DOMContentLoaded', function() {
  const sortOptions = document.querySelectorAll('select option[value="best-selling"]');
  sortOptions.forEach(option => {
    option.textContent = 'Najpopularniejsze';
  });
});